import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../Header/Navbar';
import Footer from '../Footer/Footer';
import BackToTop from '../BackToTop/BackToTop';
import Topbar from '../Header/Topbar';
import ProductCard from './ProductCard';
import Pagination from './Pagination';
import SEO from '../SEO/SEO';
import './Products.css';

const SolarProducts = () => {
  const location = useLocation();
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeSystem, setActiveSystem] = useState('all');

  const solarProducts = [
    // ==================== OFF-GRID PRODUCTS ====================
    
    // Off-Grid Solar Inverters
    {
      id: 'inverter-1',
      name: 'Solar Inverter 1KVA Pure Sine Wave',
      image: '/assets/Solar/SOLAR-1KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'off-grid'
    },
    {
      id: 'inverter-2',
      name: 'Solar Inverter 2KVA Pure Sine Wave',
      image: '/assets/Solar/SOLAR-2KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'off-grid'
    },
    {
      id: 'inverter-3',
      name: 'Solar Inverter 3KVA Pure Sine Wave',
      image: '/assets/Solar/SOLAR-3KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'off-grid'
    },
    {
      id: 'inverter-4',
      name: 'Solar Inverter 4KVA MPPT',
      image: '/assets/Solar/SOLAR-4KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'off-grid'
    },
    {
      id: 'inverter-5',
      name: 'Solar Inverter 8KVA Pure Sine Wave',
      image: '/assets/Solar/SOLAR-8KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'off-grid'
    },
    {
      id: 'inverter-6',
      name: 'Solar Inverter 10KVA MPPT',
      image: '/assets/Solar/SOLAR-10KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'off-grid'
    },

    // Off-Grid Solar Panels
    {
      id: 'solar-panel-1',
      name: 'Solar Panel 100W Mono PERC',
      image: '/assets/Solar/SOLAR-1KVA.jpeg',
      category: 'panels',
      brand: 'solar',
      systemType: 'off-grid'
    },
    {
      id: 'solar-panel-2',
      name: 'Solar Panel 250W Polycrystalline',
      image: '/assets/Solar/SOLAR-2KVA.jpeg',
      category: 'panels',
      brand: 'solar',
      systemType: 'off-grid'
    },

    // Off-Grid Solar Batteries
    {
      id: 'solar-battery-1',
      name: 'Solar Battery 150Ah Tubular',
      image: '/assets/Solar/SOLAR-3KVA.jpeg',
      category: 'batteries',
      brand: 'solar',
      systemType: 'off-grid'
    },
    {
      id: 'solar-battery-2',
      name: 'Solar Battery 200Ah Tall Tubular',
      image: '/assets/Solar/SOLAR-4KVA.jpeg',
      category: 'batteries',
      brand: 'solar',
      systemType: 'off-grid'
    },

    // Off-Grid Charge Controllers
    {
      id: 'controller-1',
      name: 'Solar Charge Controller 10A PWM',
      image: '/assets/Solar/SOLAR-8KVA.jpeg',
      category: 'controllers',
      brand: 'solar',
      systemType: 'off-grid'
    },
    {
      id: 'controller-2',
      name: 'Solar Charge Controller 20A MPPT',
      image: '/assets/Solar/SOLAR-10KVA.jpeg',
      category: 'controllers',
      brand: 'solar',
      systemType: 'off-grid'
    },

    // ==================== ON-GRID PRODUCTS ====================
    
    // On-Grid Solar Inverters
    {
      id: 'on-grid-inverter-1',
      name: 'On-Grid Solar Inverter 3KVA',
      image: '/assets/Solar/On-gird-1.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'on-grid'
    },
    {
      id: 'on-grid-inverter-2',
      name: 'On-Grid Solar Inverter 5KVA',
      image: '/assets/Solar/On-gird-2.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'on-grid'
    },
    {
      id: 'on-grid-inverter-3',
      name: 'On-Grid Solar Inverter 10KVA',
      image: '/assets/Solar/On-gird-3.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'on-grid'
    },
    {
      id: 'on-grid-inverter-4',
      name: 'On-Grid Solar Inverter 15KVA',
      image: '/assets/Solar/On-gird-4.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'on-grid'
    },

    // On-Grid Solar Panels
    {
      id: 'on-grid-panel-1',
      name: 'On-Grid Solar Panel 300W Mono',
      image: '/assets/Solar/On-gird-1.jpeg',
      category: 'panels',
      brand: 'solar',
      systemType: 'on-grid'
    },
    {
      id: 'on-grid-panel-2',
      name: 'On-Grid Solar Panel 350W Mono',
      image: '/assets/Solar/On-gird-2.jpeg',
      category: 'panels',
      brand: 'solar',
      systemType: 'on-grid'
    },

    // ==================== HYBRID PRODUCTS ====================
    
    // Hybrid Solar Inverters
    {
      id: 'hybrid-inverter-1',
      name: 'Hybrid Solar Inverter 3KVA',
      image: '/assets/Solar/SOLAR-3KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'hybrid'
    },
    {
      id: 'hybrid-inverter-2',
      name: 'Hybrid Solar Inverter 5KVA',
      image: '/assets/Solar/SOLAR-4KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'hybrid'
    },
    {
      id: 'hybrid-inverter-3',
      name: 'Hybrid Solar Inverter 8KVA',
      image: '/assets/Solar/SOLAR-8KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'hybrid'
    },
    {
      id: 'hybrid-inverter-4',
      name: 'Hybrid Solar Inverter 10KVA',
      image: '/assets/Solar/SOLAR-10KVA.jpeg',
      category: 'inverters',
      brand: 'solar',
      systemType: 'hybrid'
    },

    // Hybrid Solar Batteries
    {
      id: 'hybrid-battery-1',
      name: 'Hybrid Battery 5KWh LiFePO4',
      image: '/assets/Solar/SOLAR-3KVA.jpeg',
      category: 'batteries',
      brand: 'solar',
      systemType: 'hybrid'
    },
    {
      id: 'hybrid-battery-2',
      name: 'Hybrid Battery 10KWh LiFePO4',
      image: '/assets/Solar/SOLAR-4KVA.jpeg',
      category: 'batteries',
      brand: 'solar',
      systemType: 'hybrid'
    },

    // Hybrid Solar Panels
    {
      id: 'hybrid-panel-1',
      name: 'Hybrid Solar Panel 400W Bifacial',
      image: '/assets/Solar/SOLAR-8KVA.jpeg',
      category: 'panels',
      brand: 'solar',
      systemType: 'hybrid'
    },
    {
      id: 'hybrid-panel-2',
      name: 'Hybrid Solar Panel 450W Bifacial',
      image: '/assets/Solar/SOLAR-10KVA.jpeg',
      category: 'panels',
      brand: 'solar',
      systemType: 'hybrid'
    }
  ];

  const solarCategories = [
    { id: 'panels', name: 'Solar Panels' },
    { id: 'inverters', name: 'Solar Inverters' },
    { id: 'batteries', name: 'Solar Batteries' },
    { id: 'controllers', name: 'Solar Charge Controllers' }
  ];

  const systemTypes = [
    { id: 'off-grid', name: 'Off-Grid', icon: 'fas fa-home', color: '#FF9900' },
    { id: 'on-grid', name: 'On-Grid', icon: 'fas fa-building', color: '#28a745' },
    { id: 'hybrid', name: 'Hybrid', icon: 'fas fa-arrows-alt-h', color: '#007bff' }
  ];

  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchQuery('');
    setCurrentPage(1);
  };

  const getTotalProducts = () => {
    return solarProducts.length;
  };

  // Filter products based on search and system type
  const getFilteredProducts = (systemTypeId) => {
    let filtered = [...solarProducts];

    // Filter by system type
    if (systemTypeId !== 'all') {
      filtered = filtered.filter(product => product.systemType === systemTypeId);
    }

    // Filter by search query
    const trimmedQuery = searchQuery.trim().toLowerCase();
    if (trimmedQuery.length > 0) {
      filtered = filtered.filter(product => {
        const nameMatch = product.name.toLowerCase().includes(trimmedQuery);
        const categoryMatch = product.category.toLowerCase().includes(trimmedQuery);
        return nameMatch || categoryMatch;
      });
    }

    return filtered;
  };

  return (
    <>
      <SEO 
        title="Solar Products"
        description="Complete solar power solutions in Chidambaram. Authorized dealer for solar panels, inverters, and batteries at Galaxy Power System."
        keywords="solar panel chidambaram, solar inverter price, solar battery dealer, off-grid solar system, on-grid solar solution"
        canonicalUrl="https://galaxypowersystems.com/solar-products"
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Solar Products', url: '/solar-products' }
        ]}
      />
      <Topbar />
      <Navbar />
      <div className="container-fluid product py-5" id="products">
        <div className="container py-5">
          <div className="row mb-5">
            <div className="col-12 text-center">
              <h1 className="display-5 mb-3" style={{ color: '#FF9900' }}>
                <i className="fas fa-solar-panel me-2"></i> Solar Products
              </h1>
              <p className="lead text-muted mb-4">
                Complete solar power solutions including solar panels, inverters, batteries, 
                and charge controllers for residential and commercial applications.
              </p>
            </div>
          </div>

          <div className="row g-4 align-items-center mb-5">
            <div className="col-lg-4 col-md-12">
              <h3 className="mb-0">All Solar Products</h3>
            </div>
            
            <div className="col-lg-5 col-md-8">
              <div className="position-relative">
                <div className="d-flex border rounded-pill align-items-center" style={{ backgroundColor: '#fff', borderColor: '#FF9900', borderWidth: '2px' }}>
                  <i className="fas fa-search ps-3" style={{ color: '#FF9900' }}></i>
                  <input 
                    className="form-control border-0 rounded-pill w-100 py-2 ps-2" 
                    type="text"
                    placeholder="Search products (inverter, panel, battery...)"
                    value={searchQuery}
                    onChange={handleSearch}
                    style={{ fontSize: '14px', outline: 'none' }}
                  />
                  {searchQuery && (
                    <button 
                      type="button" 
                      className="btn btn-link text-warning pe-3"
                      onClick={clearSearch}
                      style={{ border: '0', fontSize: '16px', textDecoration: 'none' }}
                      title="Clear search"
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
              </div>
            </div>
            
            <div className="col-lg-3 col-md-4 text-end">
              <div className="badge bg-warning text-dark rounded-pill py-2 px-4">
                Total Products: {getTotalProducts()}
              </div>
            </div>
          </div>

          {/* System Type Filter Tabs */}
          <div className="row mb-5">
            <div className="col-12">
              <div className="d-flex gap-3 justify-content-center flex-wrap">
                <button
                  className={`btn px-4 py-2 rounded-pill ${activeSystem === 'all' ? 'btn-warning text-dark' : 'btn-outline-secondary'}`}
                  onClick={() => {
                    setActiveSystem('all');
                    setCurrentPage(1);
                  }}
                  style={{ fontWeight: activeSystem === 'all' ? '600' : '500' }}
                >
                  <i className="fas fa-th me-2"></i> All Systems
                </button>
                {systemTypes.map((system) => (
                  <button
                    key={system.id}
                    className={`btn px-4 py-2 rounded-pill ${activeSystem === system.id ? 'text-white' : 'btn-outline-secondary'}`}
                    onClick={() => {
                      setActiveSystem(system.id);
                      setCurrentPage(1);
                    }}
                    style={{
                      backgroundColor: activeSystem === system.id ? system.color : 'transparent',
                      borderColor: system.color,
                      color: activeSystem === system.id ? '#fff' : system.color,
                      fontWeight: activeSystem === system.id ? '600' : '500',
                      borderWidth: '2px'
                    }}
                  >
                    <i className={`${system.icon} me-2`}></i> {system.name}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* Products Section by System Type */}
          {activeSystem === 'all' ? (
            // Display all three sections
            <>
              {systemTypes.map((system) => {
                const productsInSystem = getFilteredProducts(system.id);
                return (
                  <div key={system.id} className="mb-5">
                    <div className="row mb-4 align-items-center">
                      <div className="col-12">
                        <h2 
                          style={{ 
                            color: system.color,
                            borderLeft: `5px solid ${system.color}`,
                            paddingLeft: '15px',
                            fontWeight: '600'
                          }}
                        >
                          <i className={`${system.icon} me-2`}></i>{system.name} Systems
                        </h2>
                      </div>
                    </div>

                    <div className="tab-content">
                      <div className="row g-4">
                        {productsInSystem.length > 0 ? (
                          productsInSystem.map((product, index) => (
                            <div key={product.id} className="col-md-6 col-lg-4 col-xl-3">
                              <ProductCard
                                product={product}
                                delay={`${(index % 4) * 0.2}s`}
                                brand="solar"
                                categoryId={product.category}
                              />
                            </div>
                          ))
                        ) : (
                          <div className="col-12">
                            <div className="alert alert-info text-center py-3">
                              <p className="mb-0">No products available in {system.name}</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                );
              })}
            </>
          ) : (
            // Display only the selected system type
            <>
              {systemTypes
                .filter(s => s.id === activeSystem)
                .map((system) => {
                  const productsInSystem = getFilteredProducts(system.id);
                  return (
                    <div key={system.id}>
                      <div className="row mb-4 align-items-center">
                        <div className="col-12">
                          <h2 
                            style={{ 
                              color: system.color,
                              borderLeft: `5px solid ${system.color}`,
                              paddingLeft: '15px',
                              fontWeight: '600'
                            }}
                          >
                            <i className={`${system.icon} me-2`}></i>{system.name} Systems
                          </h2>
                        </div>
                      </div>

                      <div className="tab-content">
                        <div className="row g-4">
                          {productsInSystem.length > 0 ? (
                            productsInSystem.map((product, index) => (
                              <div key={product.id} className="col-md-6 col-lg-4 col-xl-3">
                                <ProductCard
                                  product={product}
                                  delay={`${(index % 4) * 0.2}s`}
                                  brand="solar"
                                  categoryId={product.category}
                                />
                              </div>
                            ))
                          ) : (
                            <div className="col-12">
                              <div className="alert alert-warning text-center py-5">
                                <i className="fas fa-search fa-3x mb-3" style={{ color: '#FF9900', opacity: 0.5 }}></i>
                                <h4>No products found</h4>
                                <p className="mb-2">"{searchQuery}" didn't match any products</p>
                                <button 
                                  className="btn btn-warning btn-sm mt-2"
                                  onClick={clearSearch}
                                >
                                  Clear search
                                </button>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
            </>
          )}
        </div>
      </div>
      <BackToTop />
      <Footer />
    </>
  );
};

export default SolarProducts;